import React from "react";
import "./upcoming-trips.scss";
import { Link } from "react-router-dom";

const UpcomingTrips = () => {
  return (
    <section className="upcoming-trip-section">
      <div className="heading">
        <h2>Upcoming Trips</h2>
      </div>
      <div className="trips-tabs-wrapper">
        {/* Bootstrap Nav Tabs */}
        <ul className="nav nav-tabs trip-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="flights-tab"
              data-bs-toggle="tab"
              data-bs-target="#flights"
              type="button"
              role="tab"
              aria-controls="flights"
              aria-selected="false"
            >
              <img src="/images/icons/flights.svg" alt="icon" /> Flights
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="hotels-tab"
              data-bs-toggle="tab"
              data-bs-target="#hotels"
              type="button"
              role="tab"
              aria-controls="hotels"
              aria-selected="true"
            >
              <img src="/images/icons/hotels.svg" alt="icon" /> Hotels
            </button>
          </li>
        </ul>

        {/* Tab Content */}
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane fade show active"
            id="flights"
            role="tabpanel"
            aria-labelledby="flights-tab"
          >
            <div className="flight-item-box">
              <div className="badges">
                <div className="badge-cheap">Cheapest</div>
                <div className="badge-light">
                  {" "}
                  <img src="/images/icons/carry.svg" alt="icon" /> Carry-on
                  baggage included
                </div>
              </div>
              <div className="row justify-content-between align-items-center">
                <div className="col-lg-3 py-0">
                  <div className="air-line">
                    <img src="/images/icons/emirates.svg" alt="airline" />
                    <p>Emirates, A380</p>
                  </div>
                </div>
                <div className="col-lg-4 py-0">
                  <div className="flight-row">
                    <div className="title">
                      <h5>13:30</h5>
                      <p>LHR</p>
                    </div>
                    <div className="time-duration">
                      <p>8h 50m</p>
                      <img
                        src="/images/icons/flight-row.svg"
                        alt="flight-row"
                      />
                      <p>5h in Karachi</p>
                    </div>
                    <div className="title to">
                      <h5>13:30</h5>
                      <p>LHR</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 py-0">
                  <div className="price-wrap">
                    <Link to="/flight-details" className="flight-select">
                      See Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="flight-item-box">
              <div className="badges">
                <div className="badge-cheap">Cheapest</div>
                <div className="badge-light">
                  {" "}
                  <img src="/images/icons/carry.svg" alt="icon" /> Carry-on
                  baggage included
                </div>
              </div>
              <div className="row justify-content-between align-items-center">
                <div className="col-lg-3 py-0">
                  <div className="air-line">
                    <img src="/images/icons/emirates.svg" alt="airline" />
                    <p>Emirates, A380</p>
                  </div>
                </div>
                <div className="col-lg-4 py-0">
                  <div className="flight-row">
                    <div className="title">
                      <h5>13:30</h5>
                      <p>LHR</p>
                    </div>
                    <div className="time-duration">
                      <p>8h 50m</p>
                      <img
                        src="/images/icons/flight-row.svg"
                        alt="flight-row"
                      />
                      <p>5h in Karachi</p>
                    </div>
                    <div className="title to">
                      <h5>13:30</h5>
                      <p>LHR</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 py-0">
                  <div className="price-wrap">
                    <Link to="/flight-details" className="flight-select">
                      See Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="hotels"
            role="tabpanel"
            aria-labelledby="hotels-tab"
          >
            <div className="hotels-wrapper">
              <div className="card hotel-card">
                <div className="row no-gutters align-items-center">
                  <div className="col-lg-4">
                    <div className="hotel-img-slider">
                      <div
                        id="hotelCarousel"
                        className="carousel slide hotel-img-slider"
                        data-bs-ride="carousel"
                      >
                        <div className="carousel-inner">
                          <div className="carousel-item active">
                            <img
                              src="/images/hotels/hotel-1.svg"
                              alt="hotel 1"
                            />
                          </div>
                          <div className="carousel-item">
                            <img
                              src="/images/hotels/hotel-2.svg"
                              alt="hotel 2"
                            />
                          </div>
                          <div className="carousel-item">
                            <img
                              src="/images/hotels/hotel-3.svg"
                              alt="hotel 3"
                            />
                          </div>
                        </div>

                        <div className="carousel-indicators">
                          <button
                            type="button"
                            data-bs-target="#hotelCarousel"
                            data-bs-slide-to="0"
                            className="active"
                            aria-current="true"
                            aria-label="Slide 1"
                          ></button>
                          <button
                            type="button"
                            data-bs-target="#hotelCarousel"
                            data-bs-slide-to="1"
                            aria-label="Slide 2"
                          ></button>
                          <button
                            type="button"
                            data-bs-target="#hotelCarousel"
                            data-bs-slide-to="2"
                            aria-label="Slide 3"
                          ></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8 ps-lg-0 ps-lg">
                    <div className="row">
                      <div className="col-lg-9">
                        <div className="card-body">
                          <div className="hotel-details">
                            <div className="title-wrap">
                              <h3>Islamabad Serena Hotel</h3>
                              <div className="stars">
                                <img src="/images/icons/star.svg" alt="star" />
                                <img src="/images/icons/star.svg" alt="star" />
                                <img src="/images/icons/star.svg" alt="star" />
                                <img src="/images/icons/star.svg" alt="star" />
                                <img src="/images/icons/star.svg" alt="star" />
                              </div>
                            </div>
                            <div className="reviews">
                              <span className="rating-box">
                                8.9 <span>/10</span>{" "}
                              </span>
                              <span className="review-count">Very Good</span>
                            </div>
                            <div className="hotel-distance">
                              <p>
                                <img
                                  src="/images/icons/map-icon.svg"
                                  alt="Map"
                                />
                                1.8 km from centre
                              </p>
                              <Link to="">Show on Map</Link>
                            </div>
                            <div className="trip-best">
                              <img
                                src="/images/icons/trip-best.svg"
                                alt="Trip"
                              />
                              <span>No.1 of Luxury Hotels in Islamabad</span>
                            </div>
                          </div>
                          <div className="hotel-pricing-details">
                            <div className="facilities-wrap">
                              <h5>
                                Deluxe King
                                <img
                                  src="/images/icons/profile-icon.svg"
                                  alt="icon"
                                />
                                <img
                                  src="/images/icons/profile-icon.svg"
                                  alt="icon"
                                />
                                <img
                                  src="/images/icons/sofa-icon.svg"
                                  alt="icon"
                                />
                              </h5>
                              <span>Breakfast included</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="detail-link-wrap">
                          <Link to="/hotel-details" className="see-detail">
                            See Detail
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UpcomingTrips;
